{
  "1": ["ついたち", "いっぴ"],
  "2": ["ふつか"],
  "3": ["みっか"],
  "4": ["よっか"],
  "5": ["いつか"],
  "6": ["むいか"],
  "7": ["なのか"],
  "8": ["ようか"],
  "9": ["ここのか"],
  "10": ["とおか"],
  "11": ["じゅういちにち"],
  "12": ["じゅうににち"],
  "13": ["じゅうさんにち"],
  "14": ["じゅうよっか"],
  "15": ["じゅうごにち"],
  "16": ["じゅうろくにち"],
  "17": ["じゅうしちにち", "じゅうななにち"],
  "18": ["じゅうはちにち"],
  "19": ["じゅうくにち"],
  "20": ["はつか"],
  "21": ["にじゅういちにち"],
  "22": ["にじゅうににち"],
  "23": ["にじゅうさんにち"],
  "24": ["にじゅうよっか"],
  "25": ["にじゅうごにち"],
  "26": ["にじゅうろくにち"],
  "27": ["にじゅうしちにち", "にじゅうななにち"],
  "28": ["にじゅうはちにち"],
  "29": ["にじゅうくにち"],
  "30": ["さんじゅうにち"],
  "31": ["さんじゅういちにち"]
}
